
import { Mainroutes } from './Routes/Mainroutes';
import "./App.css"
function App() {



  return (
    <div className="App">
       <Mainroutes/>
    </div>
  );
}

export default App;
